import D1 from '../../components/ExcerciseTypes/Design/TypeIn'
import T6 from '../../components/ExcerciseTypes/TypeIn/T6'
import UI from '../../components/ExcerciseTypes/Design/UserInterface'
import MatchDots from '../../components/ExcerciseTypes/LineTo/MatchDots'
import ScoreByColor from '../../components/ExcerciseTypes/Design/ScoreByColor'
import PaintColorType from '../../components/ExcerciseTypes/Design/PaintColorType'
const json = {
	1: {
		// Exercise num
		unit: 'Stater',
		id: '4WB-S-P8-E1',
		audio: '',
		exerciseKey: 'img/FriendsPlus/Page8/E1/Key/E1answerKey.png',
		// exerciseKey: 'img/FriendsPlus/Page39/Key/E2answerKey.png',
		component: T6,
		inputSize: 108,
		textAlign: 'center',
		maxLength: 8,
		isHiddenCheck: true,
		stylesTextInput: {
			background: 'none',
			borderBottom: 'none',
			fontSize: 21,
			height: 22,
		},
		titleQuestion: [
			{
				num: '1',
				title: 'Read the text in the Student Book. Write.',
				color: '#234090',
			},
		],

		questions: [
			{
				title: `


        <div style=" position: relative; padding-top:20px ">
						<div> <img style='width:22cm' src='img/FriendsPlus/Page8/E1/1.jpg' /> </div>
            <div style=" position: absolute; top: 82px; left: 648px;height: 20px ">#</div>
						<div style=" position: absolute; top: 120px; left: 333px; "><input id='1'></input></div>
						<div style=" position: absolute; top: 120px; left: 593px; "><input id='2' ></input></div>
            <div style=" position: absolute; top: 158px; left: 522px; "><input id='3' ></input></div>

            
            <div style=" position: absolute; top: 302px; left: 438px;  "><input id='4'  width='116px'></input></div>
            <div style=" position: absolute; top: 302px; left: 665px; "><input id='5'  width='116px'></input></div>
            <div style=" position: absolute; top: 340px; left: 348px; "><input id='6' width='116px'></input></div>
            <div style=" position: absolute; top: 340px; left: 598px; "><input id='7' width='116px'></input></div>
            <div style=" position: absolute; top: 377px; left: 500px; "><input id='8' width='177px'></input></div>
					</div>
          `,
				// answer: ["sister","long","brown","pink,"brother","",],
				answer: [
					'sister',
					'brown',
					'eyes',
					'pink',
					'eleven',
					'brother',
					'short',
					'eyes',
					'green',
				],
			},
		],
	},
	2: {
		// Exercise num
		unit: 'Starter',
		id: '4WB-S-P8-E2',
		audio: '',
		video: '',
		component: MatchDots,
		exerciseKey: 'img/FriendsPlus/Page8/E2/Key/E2answerKey.png',
		titleQuestion: [
			{
				num: '2',
				title: 'Circle and match.',
				color: '#2E479B',
			},
		],
		question: {
			DrawLines: {
				multipleLine: true,
				boxMatch: [
					//left
					// {
					// 	boxMatchStyle: {
					// 		position: 'absolute',
					// 		top: '109px',
					// 		left: '136px',
					// 		width: 186,
					// 		height: 45,
					// 		backgroundColor: 'red',
					// 		border: '1px solid',
					// 	},
					// }, //0
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '175px',
							left: '186px',
							width: 288,
							height: 45,
							//backgroundColor: 'blue',
							//border: '1px solid',
						},
					}, //1
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '245px',
							left: '142px',
							width: 200,
							height: 55,
							//backgroundColor: 'yellow',
							//border: '1px solid',
						},
					}, //2
					//right
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '116px',
							left: '637px',
							width: 186,
							height: 45,
							//backgroundColor: 'red',
							//border: '1px solid',
						},
					}, //3
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '175px',
							left: '682px',
							width: 278,
							height: 45,
							//backgroundColor: 'blue',
							//border: '1px solid',
						},
					}, //4
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '246px',
							left: '664px',
							width: 242,
							height: 62,
							//backgroundColor: 'yellow',
							//border: '1px solid',
						},
					}, //5
					//mid
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '132px',
							left: '447px',
							width: 70,
							height: 43,
							//backgroundColor: 'pink',
							//border: '1px solid',
						},
					}, //6
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '200px',
							left: '447px',
							width: 91,
							height: 43,
							//backgroundColor: 'pink',
							//border: '1px solid',
						},
					}, //7
					{
						boxMatchStyle: {
							position: 'absolute',
							top: '286px',
							left: '447px',
							width: 144,
							height: 81,
							//backgroundColor: 'pink',
							//border: '1px solid',
						},
					}, //8
				],
				answers: ['2-5', '0-6', '4-6', '1-7', '3-6'],
				initialValue: [],
			},
			Layout: `
      <div style='display:flex; flex-direction: column'>
      <img style='padding-top:25px; padding-left:51px ;width:17cm; margin-left:194px' src="img/FriendsPlus/Page8/E2/1.jpg" />
      <img style='width:22cm; margin-bottom:50px' src="img/FriendsPlus/Page8/E2/2.jpg" />
      </div>
          <input id='0' type= 'boxMatch' />
          <input id='1' type= 'boxMatch' />
          <input id='2' type= 'boxMatch' />

          <input id='3' type= 'boxMatch' />
          <input id='4' type= 'boxMatch' />
          <input id='5' type= 'boxMatch' />

          <input id='6' type= 'boxMatch' />
          <input id='7' type= 'boxMatch' />
          
      `,
		},
	},
	3: {
		// Exercise num
		unit: 'Stater',
		id: '4WB-S-P8-E3',
		audio: '',
		component: T6,
		hideBtnFooter: true,
		exerciseKey: 'img/FriendsPlus/Page7/Key/E1answerKey.png',
		// exerciseKey: 'img/FriendsPlus/Page39/Key/E2answerKey.png',
		inputSize: 290,
		textAlign: 'center',
		maxLength: 30,

		titleQuestion: [
			{
				num: '3',
				title: 'Draw and write about you.',
				color: '#234090',
			},
		],

		questions: [
			{
				title: `
        <div style='display:flex'>
          <img style=' height:6cm; padding-right:10px' src="img/FriendsPlus/Page8/E3/1.jpg" />&ensp;
          <div style='line-height:45px'>
            <div>My name’s <input id='1' width='365px'></input> .</div>
            <div>I’m <input id='2' width='450px'></input> .</div>
            <div>I have <input id='3' width='385px'></input> and</div>
            <div> <input id='4' width='500px'></input></div>
            <div>My favorite color is # .</div>
          </div>
        </div>
        
          
          `,
				answer: ['', '', '', '', ''],
			},
		],
	},
}

export default json
